import React, { useEffect, useRef, useState } from 'react';
import Odometer from 'odometer';
import 'odometer/themes/odometer-theme-default.css';

const OdometerCounter = ({ value }) => {
  const ref = useRef(null);
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          new Odometer({
            el: ref.current,
            value: 0,
            duration: 2000,
          });

          setTimeout(() => {
            if (ref.current) ref.current.innerHTML = value;
          }, 100);

          setHasAnimated(true);
          observer.disconnect();
        }
      },
      { threshold: 0.6 } // 60% 이상 보이면 실행
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, [value, hasAnimated]);

  return (
    <div
      ref={ref}
      className="odometer"
      style={{ fontSize: '2rem', fontWeight: 700, display: 'inline-block' }}
    >
      0
    </div>
  );
};

export default OdometerCounter;